import Vue from 'vue'
import 'line-awesome/dist/line-awesome/css/line-awesome.min.css';
import App from './App.vue'
import router from './router'
import store from './store'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import i18n from './i18n' // Import i18n
Vue.use(ElementUI);

// Register scroll animation directive
Vue.directive('animate-on-scroll', {
  bind(el, binding, vnode) {
    // Animation type and configuration
    const animationType = binding.arg || 'fade-in'
    const options = binding.value || {}
    const delay = options.delay || 0
    // Add base class and animation type class
    el.classList.add('animate-on-scroll', animationType)
    if (delay) {
      el.style.transitionDelay = `${delay}ms`
    }
    // Create intersection observer
    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          el.classList.add('visible')
          observer.unobserve(el) // 只触发一次
        }
      })
    }, { threshold: 0.1 })
    observer.observe(el)
    // Store observer instance in vnode context for cleanup on destroy
    vnode.context.observers[el._uid] = observer
  },
  unbind(el, binding, vnode) {
    // Cleanup observer
    const observer = vnode.context.observers[el._uid]
    if (observer) {
      observer.disconnect()
      delete vnode.context.observers[el._uid]
    }
  }
})
Vue.config.productionTip = false

new Vue({
  router,
  store,
  i18n, // 添加 i18n 实例
  render: h => h(App)
}).$mount('#app')
